import type {
  InspectionGetNotesRequest,
  InspectionSearchRequest,
  InspectionTypeSearchRequest,
} from '@trukt/tms-api/InspectionService';
import { createKey } from './createKey';

const keyHandler = createKey('inspection');

export const InspectionServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<InspectionSearchRequest>(),
  getNotes: keyHandler.createMethod<InspectionGetNotesRequest>(),
  searchTypes: keyHandler.createMethod<InspectionTypeSearchRequest>(),
};
